function getStatesForCountry (countryCode) {

	return fetch(`/api/regions/countries/${countryCode}/states/`).then((response) => response.json());

}

export default getStatesForCountry;
